module.exports = "/_next/static/images/default_card-81cfd17e597759f5d89677c66d1eba77.svg";